var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
var ContentMore = (function (_super) {
    __extends(ContentMore, _super);
    function ContentMore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContentMore.prototype.mounted = function () {
        this.afterAmount();
    };
    ContentMore.prototype.updated = function () {
        this.afterAmount();
    };
    ContentMore.prototype.afterAmount = function () {
        var text = this.$refs.myText;
        var btn = this.$refs.showMoreBtn;
        Vue.nextTick(function () {
            if (text.scrollHeight > text.offsetHeight) {
                btn.style.display = 'block';
            }
            else {
                btn.style.display = 'none';
            }
        });
        btn.addEventListener('click', function () {
            text.classList.toggle('expand');
            btn.textContent = text.classList.contains('expand') ? '' : '查看更多';
        });
    };
    __decorate([
        Prop({
            default: "",
        })
    ], ContentMore.prototype, "text", void 0);
    ContentMore = __decorate([
        Component
    ], ContentMore);
    return ContentMore;
}(Vue));
export default ContentMore;
